import { AxiosHelper } from '../helpers/axiosHelper';

const useLogin = () => {
  const login = async (): Promise<boolean> => {
    try {
      await AxiosHelper.postWithAxios(`/login`);
      return true;
    } catch (e) {
      console.error('failed to authenticate!');
      console.error(e);
      window.location.replace('/login');
      return false;
    }
  };
  return { login };
};

export default useLogin;
